export enum StoreSalesChannelEnum {
  Offline = "Offline",
  Both = "Both",
}
